/**
 * User: herbert
 * Date: 20.10.15
 * Time: 19:22
 */

import Reflux from 'reflux';

import stepActions from '../../slxstep/actions/step-actions.js';
import steleActions from '../actions/stele-actions.js';

import scopeActions from '../actions/scope-actions.js';

import * as stepConfig from '../../../config-steps.js';

const SCOPE_PREFIX='slx-scope-';

const SCOPES=[
	{name: 'fassade'},
	{name: 'platz'},
	{name: 'objekt'},
	{name: 'weg'}
];

export default Reflux.createStore({
	init: function() {
		this.listenToMany(scopeActions);
		this.state = {
			current: [ false, false, false, false ]
			//fotos: [
			//	['uploadtest/Burgplatz-test.jpg', 'Burgplatz-test.jpg', null],
			//			['uploadtest/drei.jpg', 'drei.jpg', null],
			//			['uploadtest/fünf.jpg', 'fünf.jpg', null],
			//			['uploadtest/sechs.jpg', 'sechs.jpg', null],
			//			['uploadtest/vier.jpg', 'vier.jpd', null]
			//],
			//selected: null,
			//error: false,
			//currentFile: null,
			//progress: null,
			//thumData: null
		};
	},
	onSelect: function(scope) {
		if(scope >= 0) {
			this.state.current[scope] = !this.state.current[scope];
			this.outputScopeClass(this.state.current);
		} else {
			this.state.current = [ false, false, false, false];
			this.outputScopeClass();
		}
		steleActions.resetToScopes(this.state.current);
		//this.output();
	},
	onHover: function(tempScope) {
		//const scopes = clone(this.state.current);
		//const scopes = [false, false, false, false];
		//if(tempScope>=0) {
		//	scopes[tempScope] = true;
		//}
		//this.outputScopeClass(scopes);

		this.outputScopeClass(this.state.current, tempScope);

		steleActions.hoverScope(tempScope);
		// kein this.output() weil sich beim Hover der eigentliche scopeStore nicht ändert
	},
	onClear: function() {
		this.state.current = [ false, false, false, false ];
		stepActions.setExtraClass({scope: null});
		stepActions.switchStep(stepConfig.STEPS[0], null); // restart
		steleActions.clear();
		//this.output();
	},
	outputScopeClass: function(scopes, tempScope) {
		if(!scopes) {
			stepActions.setExtraClass({scope: null});
		} else {
			let scopeClass = '';
			for (let i = 0; i < scopes.length; i++) {
				if (scopes[i]) {
					scopeClass += SCOPE_PREFIX + SCOPES[i].name + ' ' + SCOPE_PREFIX + SCOPES[i].name + '-selected ';
				}
			}
			//if(tempScope >= 0) {
			//	setExtraClass += SCOPE_PREFIX + SCOPES[tempScope].name + '-selected';
			//}
			stepActions.setExtraClass({scope: scopeClass});
		}
	},
	output: function() {
		// NOOP
	},
	getInitialState: function() {
		return this.state;
	}
});
